// Put your application javascript here
$(document).ready(function () {


    const annBar = function() {     
        var annbarCheck = $('#annbar-status').hasClass('true');

        // Announcement Bar

        if (localStorage.hasOwnProperty("annbarHide")) {
            console.log('bar previously hidden');
        } else {
        
            var annBar = '#shopify-section-ann-bar'
            var annClose = annBar + ' .js-close'

            if (annbarCheck) {
                $('html').addClass('ann-bar-visible')
                console.log('true')
            } else {
                $('html').removeClass('ann-bar-visible')
                console.log('false')
            }


            $(annClose).on('click', function(event) {

                event.preventDefault();

                $(annBar).fadeOut(300, function(){
                    $('html').removeClass('ann-bar-visible');
                });

                window.localStorage.setItem("annbarHide", "true");
                window.localStorage.setItem("origin", "https://noon-by-noor.com");
                
            })
        }
    }

    annBar()

   
    if (Shopify.designMode) {
        // This will only happen in the theme editor
   
        document.addEventListener("shopify:section:select", function(e){
 
            console.log('select')
             
         });
         
        document.addEventListener("shopify:section:load", function(e){
            if(e.detail.sectionId === 'ann-bar') {
                annBar()
                console.log('edit')
            }
        });

        document.addEventListener("shopify:section:unload", function(e){
            if(e.detail.sectionId === 'ann-bar') {
                annBar()
                console.log('edit 2')
            }
        });

    }
      

    // Add to Cart Form –––––––––––––––––––––––––––

    let
        addToCartFormSelector = '.add-to-cart-form',
        productOptionSelector = addToCartFormSelector + ' [name*=option]';
        
    let productForm = {
            onProductOptionChanged: function(event) {
                let
                 $form = $(this).closest(addToCartFormSelector),
                 selectedVariant = productForm.getActiveVariant($form);

                $form.trigger('form:change', [selectedVariant])

            },
            getActiveVariant: function($form) {
                let
                    variants = JSON.parse(decodeURIComponent($form.attr('data-variants'))),
                    formData = $form.serializeArray(),
                    formOptions = {
                        option1: null,
                        option2: null,
                        option3: null
                    },
                    selectedVariant = null;

                $.each(formData, function(index, item) {
                    if (item.name.indexOf('option') !== -1) {
                        formOptions[item.name] = item.value;
                    }
                });

                $.each(variants, function(index, variant) {
                    if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
                        selectedVariant = variant;
                        return false;
                    }
                });

                return selectedVariant;

                // console.log(variants);
                // console.log(formData);
                // console.log(formOptions);
            },
            validate: function(event, selectedVariant) {
                console.log('form validate');
                console.log(selectedVariant);

                let
                    $form = $(this).closest(addToCartFormSelector),
                    hasVariant = selectedVariant !== null,
                    canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
                    $id = $form.find('.js-variant-id'),
                    $qty = $form.find('.js-variant-qty'),
                    $addToCartButton = $form.find('.add-to-cart-button'),
                    $price = $form.find('.js-price'),
                    formattedVariantPrice = null,
                    priceHtml = null,
                    addMsg = '.add-to-cart-button .add-msg',
                    wholeButton = '.add-to-cart-button h3.sub',
                    priceWrap = '.add-to-cart-button h3 .price-wrap',
                    formID = $form.attr('id'),
                    localAddMsg = '#' + formID + ' ' + addMsg,
                    localPriceWrap =  '#' + formID + ' ' + priceWrap,
                    localButton =  '#' + formID + ' .add-to-cart-button';

                    if (hasVariant) {
                        formattedVariantPrice = '£' + (selectedVariant.price/100).toFixed(2);
                        priceHtml = '<span class="money">' + formattedVariantPrice + '</span>';
                        window.history.replaceState(null, null, '?variant=' + selectedVariant.id);
                        // $(addMsg).html('Add to Bag');
                    } else {
                        priceHtml = $price.attr('data-default-price');
                    }

                    

                    if (canAddToCart) {
                        console.log(formID)
                        $id.val(selectedVariant.id);
                        $qty.val(selectedVariant.inventory_quantity);
                        $(localButton).prop('disabled', false);
                        // $addToCartButton.removeClass('unavailable');
                      
                        $(localAddMsg).html('Add to Bag')
                        $(localPriceWrap).removeClass('visually-hidden')
                       
                        
                        
                    } else if (!canAddToCart) {
                        $id.val('');
                        $(localButton).prop('disabled', true);
                        $qty.val(selectedVariant.inventory_quantity);
                        // $addToCartButton.addClass('unavailable');
                       $(localPriceWrap).addClass('visually-hidden')
                       
                        $(localAddMsg).html('Select Coffee')
                       
                        // $(addMsg).html('Out of Stock')
                    }

                    $price.html(priceHtml);
                    // currencyPicker.onMoneySpanAdded()
                    
                    console.log(canAddToCart);

            },
            init: function () { 
                $(document).on('change', productOptionSelector, productForm.onProductOptionChanged);
                $(document).on('form:change', addToCartFormSelector, productForm.validate);
            }
        };
        
        productForm.init();



    // Ajax Cart –––––––––––––––––––––––––––––––––

    let 
        miniCartContentSelector = '.js-mini-cart-contents';

    let ajaxify = {
        onAddToCart: function (event) {
            event.preventDefault();
        
            $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(this).serialize(),
            dataType: 'json',
            success: ajaxify.onCartUpdated,
            error: ajaxify.onError
            });
        },
        onCartUpdated: function() {
           
        let
            $miniCartFieldset = $(miniCartContentSelector + '.js-cart-fieldset');
            
            $miniCartFieldset.prop('disabled', true);
    

        $.ajax({
          type: 'GET',
          url: '/cart',
          context: document.body,
          success: function(context) {
            let
              $dataCartContents = $(context).find('.js-cart-page-contents'),
              dataCartHtml = $dataCartContents.html(),
              dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
              $miniCartContents = $(miniCartContentSelector),
              $cartItemCount = $('.js-cart-item-count');
    
            $cartItemCount.text(dataCartItemCount);
            $miniCartContents.html(dataCartHtml);
            // currencyPicker.onMoneySpanAdded();
    
            if (parseInt(dataCartItemCount) > 0) {
                ajaxify.openCart(); 
            }
            else {
                ajaxify.closeCart();
            }
          }
        });
        },
        onError: function(XMLHttpRequest, textStatus) {
        let data = XMLHttpRequest.responseJSON;
        alert(data.status + ' - ' + data.message + ': ' + data.description);
        console.log('error')
        },
        onCartButtonClick: function(event) {
            event.preventDefault();
      
            let isCartOpen = $('html').hasClass('mini-cart-open');
      
            if (!isCartOpen) {
                ajaxify.openCart();
            }
            else {
                ajaxify.closeCart();
            }
        },
        openCart: function() {
            $('html').addClass('mini-cart-open'); 
            // $('#mini-cart').removeClass('visually-hidden');
            // $('#mini-cart').removeClass('mini-cart-close');
        },
        closeCart: function() {
            $('html').removeClass('mini-cart-open');
            // $('#mini-cart').addClass('visually-hidden');
            // $('html').addClass('mini-cart-close');
        }, 
        init: function() {
            $(document).on('submit', addToCartFormSelector, ajaxify.onAddToCart);
            $(document).on('click', '.cart-close', ajaxify.closeCart);
            $(document).on('click', '.js-cart-link', ajaxify.onCartButtonClick);
            
        }
    }

    ajaxify.init();



    // Quantity Fields –––––––––––––––––––––––––––––––––

    let 
    quantityFieldSelector = '.js-quantity-field',
    quantityButtonSelector = '.js-quantity-button',
    quantityPickerSelector = '.js-quantity-picker',
    quantityPicker = {
        onButtonClick: function(event) {
        // alert('button clicked');
        let
            $button = $(this),
            $picker = $button.closest(quantityPickerSelector),
            $quantity = $picker.find('.js-quantity-field'),
            quantityValue = parseInt($quantity.val()),
            max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;
    
        if ($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
            // do something for plus click
            $quantity.val(quantityValue + 1).change();
        }
        else if ($button.hasClass('minus')) {
            // do something for minus click
            $quantity.val(quantityValue - 1).change();
        }
        },
        onChange: function(event) {
        let
            $field = $(this),
            $picker = $field.closest(quantityPickerSelector),
            $quantityText = $picker.find('.js-quantity-text'),
            shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
            shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
            $minusButton = $picker.find('.js-quantity-button.minus'),
            $plusButton = $picker.find('.js-quantity-button.plus');
    
        $quantityText.text(this.value);
    
        if (shouldDisableMinus) {
            $minusButton.prop('disabled', true);
      
        }
        else if ($minusButton.prop('disabled') === true) {
            $minusButton.prop('disabled', false);
            
        }
    
        if (shouldDisablePlus) {
            $plusButton.prop('disabled', true);
            $plusButton.addClass('disabled'); 
        }
        else if ($plusButton.prop('disabled') === true) {
            $plusButton.prop('disabled', false);
            $plusButton.addClass('disabled');
        }
        },
        init: function() {
        $(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
        $(document).on('change', quantityFieldSelector, quantityPicker.onChange);
    
        }
    };

    quantityPicker.init();


    // Line Item –––––––––––––––


    let 
        removeLineSelector = '.js-remove-line',
        lineQuantitySelector = '.js-line-quantity';

    let lineItem = {
        isInMiniCart: function(element) {
            let
                $element = $(element),
                $miniCart = $element.closest(miniCartContentSelector),
                isInMiniCart = $miniCart.length !== 0;

            return isInMiniCart;

        },
        onLineQuantityChanged: function () {
            let 
                quantity = this.value, 
                id = $(this).attr('id').replace('updates_', '');
                changes = {
                    quantity: quantity,
                    id: id
                },
                isInMiniCart = lineItem.isInMiniCart(this);
                
                console.log(changes)

                if (isInMiniCart) {
                    $.post('/cart/change.js', changes, ajaxify.onCartUpdated, 'json');
                }
        },
        onLineRemoved: function(event) {

            let 
                isInMiniCart = lineItem.isInMiniCart(this);

            if (isInMiniCart) {

                event.preventDefault();
                
                let
                    $removeLink = $(this),
                    removeQuery = $removeLink.attr('href').split('change?')[1];

                $.post('/cart/change.js', removeQuery, ajaxify.onCartUpdated, 'json');
            }
        },
        init: function() {
            $(document).on('click', removeLineSelector, lineItem.onLineRemoved);
            $(document).on('change', lineQuantitySelector, lineItem.onLineQuantityChanged)
        }
    };

    lineItem.init();




    ////////////// Search Input 
    let 
        searchInputSelector = '.js-search-input',
        searchSubmitSelector = '.js-search-submit',
        onSearchInputKeyUp = function () {
            let 
                $form = $(this).closest('form'),
                $button = $form.find(searchSubmitSelector),
                shouldDisableButton = this.value.length === 0;

                console.log(shouldDisableButton);

                $button.prop('disabled', shouldDisableButton);
        };
    $(document).on('keyup', searchInputSelector, onSearchInputKeyUp);


    // Menu  
    
    let
        menuButtonSelector = '.js-sidebar-link',
        menuLinksSelector = ".mob-sidebar-inner a:not('.parent-link')",
        menuCloseSelector = '.js-menu-close',
        menuCartSelector = '.js-menu-cart-link',
        onMenuButtonClick = function(event) {
            event.preventDefault();
  
            let isMenuOpen = $('html').hasClass('mob-menu-open');
  
            if (!isMenuOpen) {
                openMenu();
            }
            else {
                closeMenu();
            }
        },
        openMenu = function() {
            $('html').addClass('mob-menu-open');
        },
        closeMenu = function() {
            $('html').removeClass('mob-menu-open');
            // console.log('close menu');
        };

    $(document).on('click', menuButtonSelector, onMenuButtonClick);
    $(document).on('click', menuLinksSelector, closeMenu);
    $(document).on('click', menuCloseSelector, closeMenu);
    $(document).on('click', menuCartSelector, closeMenu);



    // //////////  Reccomendations

    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations");
        if (productRecommendationsSection === null) { return; }
        // Read product id from data attribute
        var productId = productRecommendationsSection.dataset.productId;
        // Read base URL from data attribute
        var baseUrl = productRecommendationsSection.dataset.baseUrl;
        // Read limit from data attribute
        var limit = productRecommendationsSection.dataset.limit;
        // Build request URL
        var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();
        request.open("GET", requestUrl);
        request.onload = function() {
          if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          }
        }; 
        request.send();
      };
   
     // Listen for changes done in the Theme Editor
      document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
          loadProductRecommendationsIntoSection();
        }
      });
      // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();


    //   Instagram

        // Data from Block
    const $instaWrap = $('section.insta-wrap')
    const $placeHolder = $('section.insta-wrap .placeholder')
    var localLimit = $instaWrap.attr('data-limit')
    if ($(window).width() < 780) {
        localLimit = 1
    } 

    // Established Code
    const accessToken = "IGQVJVRDlqbVFSSXhLcUV2UXIxR3RiUDI4MkpfYzI3V3NJQ0syaGpLdEp6ZA085TGthSFBLODhoUzB4WksxbDNEV2lQczVVZAGRlejk2aXkwaVJySjJpTmJYRXF1LXlpNXJTNDgxcVJycmdhcUdmQXJTUAZDZD"
    const fields = "id,media_type,media_url,timestamp,permalink"
    const apiUrl = "https://graph.instagram.com/me/media?fields=" + fields + "&access_token=" + accessToken

    const refreshAccessToken = async () => {
    const superhiApi = "https://api.superhi.com/api/test/token/instagram?access_token=" + accessToken
    
    const response = await fetch (superhiApi) 
    const {access_token} = await response.json()
    return access_token
    
    }


    const fetchPosts = async () => {
    try {
        const newToken = await refreshAccessToken()
        const apiUrl = "https://graph.instagram.com/me/media?fields=" + fields + "&access_token=" + newToken

        
        
        const response = await fetch(apiUrl)
        const {data} = await response.json()
    
        $placeHolder.hide()

        data.slice(0,localLimit).forEach(post => {
            
        

        let a = document.createElement("a")
        a.href = post.permalink
        a.target = "_blank"
        a.rel = "norefferer noopener"
        a.className= "insta-card"

        
        if (post.media_type === 'VIDEO') {
            let video = document.createElement("video")
            video.src = post.media.url
            video.preload = true
            video.autoplay = true
            video.muted = true
            video.loop = true
            a.appendChild(video)
        } else {
        let img = document.createElement("img")
        img.src = post.media_url 
        a.appendChild(img)
        }

        let container = document.createElement("div")
        container.className= "insta-card"

        container.append(a)

        $instaWrap.append(container)
        
        })
    } catch (error) {
        $placeHolder.html('Cannot Fetch Posts')
        console.error(error)
    }
    } 

    var indexCheck = $('body').hasClass('index');

    if (indexCheck) {
    fetchPosts();
    }



    // Flip

    let 
        productCard = '.product-card',
        card = productCard + ' .card',
        cardInner = productCard + ' .card-inner',
        readMore = cardInner + ' a.read-more',
        addForm = cardInner + ' form',
        back = addForm + ' .back',
        title = cardInner + ' .title',
        miniDescr = addForm + ' .mini-description',
        option = addForm + ' .product-option-row';


    $(readMore).on('click', function(event) {
        event.preventDefault();

        var cardId= $(this).closest(cardInner).attr('data-card');
        var formID= $(this).closest(addForm).attr('id');
        var thisForm = 'form#' + formID;
        var thisCard =  productCard + '.' + cardId;
        var versoCheck = $(this).closest(cardInner).hasClass('verso');
        
        let
            thisBack = thisForm + ' .back',
            thisTitle = thisCard + ' .card-inner' + ' .title',
            thisMiniDescr = thisForm + ' .mini-description',
            thisOption = thisForm + ' .product-option-row';
        
        if (versoCheck) {
            $(this).closest(cardInner).removeClass('verso');
            $(this).closest(cardInner).addClass('recto');
            $(this).html('Read Less')
            $(this).addClass('recto')
            $(this).removeClass('verso')

            $(thisBack).removeClass('visually-hidden');

            $(thisTitle).addClass('visually-hidden');
            $(thisMiniDescr).addClass('visually-hidden');
            $(thisOption).addClass('visually-hidden');

        } else {
            $(this).closest(cardInner).addClass('verso');
            $(this).closest(cardInner).removeClass('recto');
            $(this).html('Read More')
            $(this).addClass('verso')
            $(this).removeClass('recto')

            $(thisBack).addClass('visually-hidden');

            $(thisTitle).removeClass('visually-hidden');
            $(thisMiniDescr).removeClass('visually-hidden');
            $(thisOption).removeClass('visually-hidden');
        }


    })


    $(card).each(function() {

        var cardHeight = $(this).height();

        console.log(cardHeight)
        $(this).css('height', cardHeight)
        

    })


    // $('#fullpage').fullpage({
    //     //options here
        
    // });

    // //methods
    // $.fn.fullpage.setAllowScrolling(true);







})